import React, { useState, useEffect } from "react";
import campagneSMSService from "./../../../../services/MarketingService/CampagneSMSService"
import { useParams } from "react-router-dom";

function StatCampagneSMS() {
  const [data, setData] = useState({});
  const { id } = useParams();

  const fetchData = async () => {
    try {
      campagneSMSService.getCampagneSMSByID(id).then((response) => {
        setData(response.data.success);

      })
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    fetchData();
  }, [id]);

  return (
    <div className="content-wrapper" style={{ marginTop: "0" }}>

      <div className="content-header">
        <div className="container-fluid">
          <div className="row mb-2">
            <div className="col-sm-6">
              <h1 className="m-0">Campagne SMS </h1>
            </div>
            <div className="col-sm-6">
              {/* <ol className="breadcrumb float-sm-right">
                <li className="breadcrumb-item">
                  <a href="#">Marketing</a>
                </li>
                <li className="breadcrumb-item">
                  <a href="/Campagne">Campagne</a>
                </li>
                <li className="breadcrumb-item">
                  <a href="/Campagne/PageCampagneS">SMS</a>
                </li>
                <li className="breadcrumb-item active">
                  {data && data.nom ? data.nom : ""}
                </li>{" "}
              </ol> */}
            </div>
          </div>
        </div>
      </div>
      {/* /.content-header */}
      {/* content */}
      <section className="content">
        {/* container-fluid */}
        <div className="container-fluid">
          <div className="card card-primary card-outline">
            <div className="card-header">
              <h5 className="m-0">{data && data.nom ? data.nom : ""}</h5>
            </div>
            <div className="card-body">
              <div>
                {data ? (
                  <div>
                    <h2>nom : {data.nom}</h2>
                    <p>Contenu : {data.contenu}</p>
                    <h3>Liste des clients :</h3>
                    <table className="table">
                      <thead>
                        <tr>
                          <th>Nom</th>
                          <th>Prénom</th>
                          <th>Numéro</th>
                          <th>Adresse</th>
                          {/* <th>Pays</th> */}
                        </tr>
                      </thead>
                      <tbody>
                        {data.clients &&
                          data.clients.map((client) => (
                            <tr key={client.id}>
                              <td>{client.lastName}</td>
                              <td>{client.firstName}</td>
                              <td>{client.phoneNumber}</td>
                              <td>{client.rue},{client.ville}{client.pays}</td>
                              {/* <td>{client.pays}</td> */}
                            </tr>
                          ))}
                      </tbody>
                    </table>
                  </div>
                ) : (
                  <p>Chargement des données...</p>
                )}
              </div>
            </div>
          </div>

        </div>
      </section>
    </div>

  );
}

export default StatCampagneSMS;
